import defaultState from '../defaultState';

const defaultActiveOrg = defaultState.activeOrganisation;

export default function activeOrganisation(state = defaultActiveOrg, action) {
  switch (action.type) {
    case 'UPDATE_ACTIVE_ORGANISATION':
      return {
        ...defaultActiveOrg,
        ...action.organisation
      }

    case 'LOGOUT':
      return defaultActiveOrg;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activeOrganisation.js